import { CorrBtnStatesConstants } from "./CorrectionButtonTypes";

export const CorrectionBtnStates: CorrBtnStatesConstants = {
  DEFAULT: 'DEFAULT',
  CORRECT: 'CORRECT',
  INCORRECT: 'INCORRECT',
  TRY_AGAIN: 'TRY_AGAIN',
  CONTINUE: 'CONTINUE'
};
